import { Component, Input, Output, EventEmitter, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { HtmlBase, BObjectModel, CustomgridModel, ParameterBoModel, CustomGridService, CustomgridComponent } from 'projects/lib-components/src/public_api';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-listeModules',
  templateUrl: './listeModules.component.html',
  styleUrls: ['./listeModules.component.css'],
})



export class ListeModulesComponent implements OnChanges {
  @Input() identApprenant: string;
  @Input() identCycle: string;

  @Output() GetResult: EventEmitter<string> = new EventEmitter<string>();

  // public listUsersSelected: UserSelected[];

  // CUSTOM GRID INFOS
  customgridName: any;
  idDonnee: string;
  idDonnee2: string;
  customgridParam: any;
  activeButton: HtmlBase[];
  public model: BObjectModel;
  public cgModel: CustomgridModel;
  public pBoModel: ParameterBoModel;
  public LocationParam: string;
  public typeModalPage: string;
  customgridNameFils: string;
  customgridParamsFils: CustomgridModel;
  public isSelected: boolean;
  public tutu = false;
  @ViewChild(CustomgridComponent, { static: false }) customgrid: CustomgridComponent;

  // // Mail
  // afficheSendMail: boolean;
  // listModelsMail: ModelMail[];
  // selectedModelMail: string;

  // // Modal confirmation envoi mail
  // @ViewChild('modalConfirmMail') modalConfirmMail: ElementRef;

  // // Modal close btn
  // @ViewChild('closeConfirmMail') closeConfirmMail: ElementRef;

  // #region constructeur
  constructor(
    protected activatedRouter: ActivatedRoute,
    protected http: HttpClient,
    protected router: Router,
    protected domSanitizer: DomSanitizer,
    protected customgridservice: CustomGridService
  ) { }
  // #endregion

  // #region variables gloables
  // #endregion

  // #region cycle de vie
  ngOnChanges(changes: SimpleChanges): void {
    // this.initData();
    this.getCustomGrid(changes);
  }
  // #endregion




  // #region private functions


  // /***************************************************** CUSTOM GRID ************************************************/
  private getCustomGrid(changes: SimpleChanges): void {
    this.isSelected = false;

    // this.activatedRouter.params.subscribe(
    // (params: Params) => {
    // Nom de la custom grid
    // this.customgridName = 'ListeModulesApprenantEL';
    // Liste des boutons
    this.activeButton = new Array<HtmlBase>();
    const btnSave: HtmlBase = new HtmlBase(`btnEnregistrer`, `BUTTON`);
    btnSave.Visible = false;
    this.activeButton.push(btnSave);
    const btnRemove: HtmlBase = new HtmlBase(`btnSupprimer`, `BUTTON`);
    btnRemove.Visible = false;
    this.activeButton.push(btnRemove);
    const btnCreate: HtmlBase = new HtmlBase(`btnModeCreer`, `BUTTON`);
    btnCreate.Visible = false;
    this.activeButton.push(btnCreate);
    // IDDONNEE

    this.idDonnee = this.identCycle;
    // IDDONNEE2 (utilisation de cet ident temporairement --remplacement de IDRELATION-- afin de pouvoir remplacer 2 idents dans la requête)
    this.idDonnee2 = this.identApprenant;

    // Pour rappeler le customGrid en cas de changement de cycle --> A AMELIORER...
    if (this.customgrid) {
      this.customgrid.idDonnee = this.identCycle;
      this.customgrid.idRelation = this.identApprenant;
      if (changes.identCycle && !changes.identCycle.firstChange) {
        this.customgrid.getDataServer();
      }
    }
    


    this.customgridservice.getItem().subscribe(
      (result: any) => {
        switch (result.Action) {
          case `ANG_PAGE`:
            this.model = result;
            this.model.ShowSaveButton = true;
            this.typeModalPage = 'ANG_PAGE';
            break;
          case `ANG_INSERT_DOC`:
            this.model = result;
            this.typeModalPage = 'ANG_INSERT_DOC';
            break;
          case `ANG_CUSTOMGRID`:
            this.cgModel = result;
            this.customgridNameFils = this.cgModel.cgParameters.FileName;
            this.customgridParamsFils = this.cgModel;
            this.typeModalPage = 'ANG_CUSTOMGRID';
            break;
          case `ANG_SEGMENTATION`:
            this.pBoModel = result;
            this.typeModalPage = 'ANG_CUSTOMGRID';
            break;
          case `ANG_LIEU_STAGE`:
            this.LocationParam = `${result.P1}|${result.P2}`;
            this.typeModalPage = 'ANG_LIEU_STAGE';
            break;
          case `ANG_GESTION_CYCLE_EL`:
            this.model = result;
            this.typeModalPage = 'ANG_STATS';
            break;
          case `ANG_STATS`:
            this.model = result;
            this.GetResult.emit(`${this.model.IdDonneeFils}`);
            break;
          default:
            break;
        }
      }
    );
  }
  // #endregion
}
